// Import model
import { FilterInstallationTypeOptionRequest } from '../models/FilterInstallationTypeOptionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { InstallationTypeOptionCondition } from '../models/InstallationTypeOptionCondition';
import { InstallationTypeOptionFields } from '../models/InstallationTypeOptionFields';
import { InstallationTypeOptionIndexedFields } from '../models/InstallationTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { InstallationTypeOptionConditionSerializer } from './InstallationTypeOptionConditionSerializer';
import { InstallationTypeOptionFieldsSerializer } from './InstallationTypeOptionFieldsSerializer';
import { InstallationTypeOptionIndexedFieldsSerializer } from './InstallationTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterInstallationTypeOptionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterInstallationTypeOptionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterInstallationTypeOptionRequest instance
   */
  static deserialize(json: string): FilterInstallationTypeOptionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterInstallationTypeOptionRequest instance
   */
  static fromObject(obj: any): FilterInstallationTypeOptionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterInstallationTypeOptionRequest');
    }


    const instance: FilterInstallationTypeOptionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as InstallationTypeOptionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as InstallationTypeOptionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        InstallationTypeOptionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterInstallationTypeOptionRequest instances
   */
  static deserializeArray(json: string): FilterInstallationTypeOptionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterInstallationTypeOptionRequest instance to a JSON string
   */
  static serialize(instance: FilterInstallationTypeOptionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterInstallationTypeOptionRequest instance to a plain object
   */
  static toObject(instance: FilterInstallationTypeOptionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        InstallationTypeOptionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterInstallationTypeOptionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterInstallationTypeOptionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
